import Vue from 'vue'
import App from './App'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/basic.css'
import '../static/css/iconfont.css'
import api from '../static/js/url-config'
import timeutil from '../static/js/timeutil'
import httputil from '../static/js/httputil'
import accountutil from '../static/js/accountutil'
import ElementUI from 'element-ui'
import router from './router'

Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.prototype.api = api;
Vue.prototype.timeutil = timeutil;
Vue.prototype.httputil = httputil;
Vue.prototype.accountutil = accountutil;


new Vue({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App },
  data:{
    eventHub: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js